<template>
  <div class="gallery" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>图片库
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">数据列表</div>
        <div class="create">
          <button @click="create()" class="btn1">新建相册</button>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="albums"
          ref="multipleTable"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" label width="40" type="selection"></el-table-column>
          <el-table-column label="封面" align="center" width="120">
            <template slot-scope="scope">
              <img class="cover" v-bind:src="serve+'/'+scope.row.cover" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="图片数"
            prop="image_count"
            width="100"
            style="text-align:center"
          ></el-table-column>
          <el-table-column align="center" prop="name" label="相册名称" width="150"></el-table-column>
          <el-table-column align="center" prop="info" label="相册描述"></el-table-column>
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="8">
                  <button @click="view(scope.row.id)" class="btn2">查看</button>
                </el-col>
                <el-col :span="8">
                  <button @click="edit(scope.row.id)" class="btn2">编辑</button>
                </el-col>
                <el-col :span="8">
                  <button @click="delThis(scope.row.id)" class="btn2">删除</button>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager">
        <el-row>
          <el-col :span="2" style="padding-left:10px;">
            <el-checkbox v-model="selectAll" style="line-height: 34px">全选</el-checkbox>
          </el-col>
          <el-col :span="8">
            <button @click="del()" class="btn1">批量删除</button>
          </el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="pages"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>

  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "gallery",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      selectAll: false,
      idString: "",
      albums: [],
      page: null,
      total: null,
      pages: null,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token")
    };
  },
  watch: {
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  mounted() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "图片管理";
    this.getData(1);
  },
  methods: {
    edit(id) {
      this.$router.push({
        path: "edit_gallery/" + id
      });
    },
    view(id) {
      this.$router.push({
        path: "view_gallery/" + id
      });
    },
    toggleSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    setPage(v) {
      this.page = v;
      this.getData(v);
      this.selectAll = false;
    },
    getData(page) {
      var that = this;
      this.axios
        .get(this.serve + "/admin/get_photo_album", {
          params: { page: page, username: this.username, token: this.token }
        })
        .then(function(res) {
          var json = res.data;console.log(res);
          if (res.status == "200" && json.code != "403") {
            that.page = json.now_page;
            that.pages = json.page_num;
            var newAlbums = [];
            for (var key in json) {
              if (json[key].name) {
                newAlbums.push(json[key]);
              }
            }
            that.albums = [];
            that.albums = newAlbums;
          } else if (json.status == "error" || json.code == "403") {
            that.role = false;
          }
        });
    },
    del() {
      var that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delete_photo_albums", {
              params: {
                ids: this.idString,
                token: this.token,
                username: this.username
              }
            })
            .then(function(res) {
              if (res.data.status == "success") {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.getData(that.page);
              }else if(res.code == '403'){
                 that.$message.error(res.msg); 
              } else {
                that.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    create() {
      this.$router.push({
        path: "/admin/create_gallery"
      });
    },
    handleSelectionChange(val) {
      this.idString = "";
      var tmpString = "";
      for (var item of val) {
        if (tmpString == "") {
          tmpString = item.id;
        } else {
          tmpString = tmpString + "," + item.id;
        }
      }
      this.idString = tmpString;
    },
    delThis(id) {
      var that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delete_photo_album", {
              params: {
                id: id,
                username: this.username,
                token: this.token
              }
            })
            .then(function(res) {
              if (res.status == "200" && res.data.code != '403') {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.getData(that.page);
              }else if(res.data.code == '403'){
                 that.$message.error(res.data.msg); 
              } else {
                that.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>
<style lang="scss">
.gallery {
  .btn2 {
    color: #606266;
  }
  min-height: 1000px;
  background: #f5f5f5;
  color: #333;
  height: 700px;
  .create {
    float: right;
    margin-right: 20px;
    padding-top: 7px;
  }
  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>